
import { call, put, takeEvery } from 'redux-saga/effects'
import userActions from './userActions'
import userTypes from './userTypes'
import UserService from '../../services/UserService'
import notificationActions from '../notifications/notificationActions'

function * addUser ({ payload }) {
  try {
    const { data } = yield call(UserService.addUser, payload)
    yield put(userActions.addUserSuccess(data))
  } catch (error) {
    if (error?.data?.auth0_id) {
      yield put(userActions.addUserSuccess(error?.data))
    } else {
      yield put(notificationActions.SendToast({ message: error?.message || 'Something went wrong. Please contact support', type: 'error' }))
      yield put(userActions.addUserFailure(error))
    }
  }
}

export function * onAddUser () {
  yield takeEvery(userTypes.LOGIN, addUser)
}

export function * userSaga () {
  yield takeEvery(userTypes.ADD_USER, addUser)
}
